import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Youko = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 20 20"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.418 12.08c-.548-1.046-2.126-1.715-2.806-2.642.459-1.061 2.951-1.714 2.74-3.565-.151-1.337-2.16-1.411-2.675-.33-.386.445-.8.863-1.24 1.254-.212.27-.451.512-.718.726-.31.326-.56.71-.979.925V5.873c-.01-1.4-2.6-1.4-2.61 0v7.33c.113.522.348.923.913.99h.784c.537-.095.843-.425.913-.99v-1.586c0-.55-.101-1.476.261-.924.532.526 1.28 1.093 1.958 1.716.65.6 1.273 1.569 1.958 1.717 1.401.304 2.02-1.057 1.501-2.046zM8.193 4.156c-.556.389-.866 1.589-1.24 2.443-.411.94-.773 1.886-1.174 2.575C4.693 7.93 3.953 5.168 2.646 4.156c-.421-.326-1.346-.317-1.762 0-1.126.857.004 2.374.457 3.17.994 1.744 2.096 3.611 2.937 5.216C3.73 14 .969 18.123 4.669 17.89c.896-.586 1.275-1.804 1.762-2.906.996-2.256 1.842-4.205 2.872-6.537.428-.97 1.459-2.402 1.24-3.5-.175-.87-1.498-1.387-2.35-.792z"
  }));
});
Youko.displayName = 'Youko';
export var YoukoDimensions = {
  height: 20,
  width: 20
};